import { usePostHogFeatureFlag } from "~/hooks/usePostHogFeatureFlag";

import { TrainingProgramAgentDrawer } from "./TrainingProgramAgentDrawer";
import { TRAINING_PROGRAM_AGENT_FEATURE_FLAG } from "./trainingProgramAgentFeatureFlag";
import {
  closeTrainingProgramAgentDrawer,
  openTrainingProgramAgentDrawer,
  useTrainingProgramAgentDrawerOpen,
} from "./trainingProgramAgentDrawerStore";

/** `bubbleOffset` podnosi FAB nad bubble asystenta AI (TRE-2313), gdy oba są widoczne. */
export const TrainingProgramAgentHost = ({ bubbleOffset = 0 }: { bubbleOffset?: number }) => {
  const { enabled } = usePostHogFeatureFlag(TRAINING_PROGRAM_AGENT_FEATURE_FLAG);
  const open = useTrainingProgramAgentDrawerOpen();

  if (!enabled) return null;

  return (
    <TrainingProgramAgentDrawer
      open={open}
      onClose={closeTrainingProgramAgentDrawer}
      onOpen={openTrainingProgramAgentDrawer}
      bubbleOffset={bubbleOffset}
    />
  );
};
